import { render, staticRenderFns } from "./BilllingIframe.vue?vue&type=template&id=29def4ea"
import script from "./BilllingIframe.vue?vue&type=script&lang=js"
export * from "./BilllingIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports